export { DocumentRemove as default } from './DocumentRemove';
